import React, {useEffect, useState} from 'react';
import {connect, useDispatch} from "react-redux";
import Loader from "./layout/loading/loader";
import {Formik} from "formik";
import {object, string} from 'yup';
import {useNavigate, useParams} from "react-router-dom";
import {Business} from "@mui/icons-material";
import SubmitButton from "./layout/forms/SubmitButton";
import PageTitle from "./layout/PageTitle";
import Constants from "../../utils/constants";
import {agencesActions} from "../../modules/agences/agences.actions";
import AgenceDataField from "./agences/form/AgenceDataField";
import Grid from "@mui/material/Grid2";

const agenceValidationSchema = object({
    libelle: string()
        .required("Le libellé est requis")
        .max(255, 'Le libellé ne doit pas dépasser 255 caractères'),
    codeCouleur: string()
        .required("La couleur est requise"),
});

function AgenceNewOrEdit({...props}) {
    const dispatch = useDispatch();
    const params = useParams();
    const navigate = useNavigate();
    const [mode, setMode] = useState("create");
    const [agenceId, setAgenceId] = useState(null);

    useEffect(() => {
        if (params.hasOwnProperty("id")) {
            setMode("edit");
            setAgenceId(params.id);
        } else {
            setMode("create");
            setAgenceId(null);
        }
    }, [params]);

    useEffect(() => {
        if (agenceId && (String(props.agence?.id) !== String(agenceId)) && !props.loading && !props.error) {
            dispatch(agencesActions.fetchAgence(agenceId));
        }
    }, [dispatch, agenceId, props.agence, props.loading, props.error]);

    const handleSubmit = (values) => {
        if (mode === "create") {
            dispatch(agencesActions.createAgence(values, () => {
                navigate(Constants.APP_ROUTE_ADMIN_AGENCES);
            }));
        } else {
            dispatch(agencesActions.updateAgence(agenceId, values, () => {
                navigate(Constants.APP_ROUTE_ADMIN_AGENCES);
            }));
        }
    };

    const initialValues = {
        libelle: props.agence?.libelle ?? '',
        codeCouleur: props.agence?.codeCouleur ?? '#000000',
    };

    if (props.loading) {
        return <Loader/>;
    }

    return (
        <>
            <PageTitle
                title={mode === "create" ? "Nouvelle agence" : `Modifier l'agence ${props.agence?.libelle || '...'}`}
                icon={<Business/>}
            />
            <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                validationSchema={agenceValidationSchema}
                onSubmit={(values, {setSubmitting}) => {
                    handleSubmit(values);
                }}
            >
                {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                  }) => (
                    <form onSubmit={handleSubmit}>
                        <AgenceDataField
                            values={values}
                            errors={errors}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                        />
                        <Grid container justifyContent="center" style={{marginTop: '2rem'}}>
                            <Grid size={4}>
                                <SubmitButton submitting={isSubmitting && !props.error}/>
                            </Grid>
                        </Grid>
                    </form>
                )}
            </Formik>
        </>
    );
}

const mapStateToProps = function (state) {
    return {
        agence: state.agences.agence,
        loading: state.agences.loading,
        error: state.agences.error,
    };
};

export default connect(mapStateToProps)(AgenceNewOrEdit);
